import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

/**
 * Blocks access to guest-only routes (e.g., /sign-in) when already authenticated.
 * Cross-tab login while on sign-in is handled by IdleSessionService.
 */
export const NoAuthGuard: CanActivateFn | CanActivateChildFn = () => {
    const router: Router = inject(Router);
    const auth: AuthService = inject(AuthService);

    if (auth.isAuthenticated) {
        return router.parseUrl('/signed-in-redirect');
    }

    return true;
};
